import App from './App.svelte';

const app = new App({
	target: document.getElementById('tax-estimator')
});
export default app;